import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-call-rail-leads-table",
  templateUrl: "./call-rail-leads-table.component.html",
  styleUrls: ["./call-rail-leads-table.component.scss"],
})
export class CallRailLeadsTableComponent implements OnInit, OnDestroy {

  ngUnsubscribe = new Subject<void>()
  @Input() dataSource: any[] = [];
  @Input() leadSearchForm: FormGroup;
  @Input() columns: any[] = [];
  @Input() partnerId: string = "";
  @Input() pageSize: number = 30;
  @Input() pageIndex: number = 0;
  @Input() leadSourceTabName = "All";
  @Output() search = new EventEmitter<any>();

  constructor(
    private router: Router,
    public commonService: CommonService
  ) {}

  ngOnInit(): void {}
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  searchData() {
    this.search.emit(this.leadSearchForm.value);
  }
  navigateDetailsPage(data: any) {
    this.router.navigateByUrl(
      "/lead/callrail-lead-details/" + data.callRailLeadId
    );
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
